import { Injectable, OnDestroy } from '@angular/core';
import { Setting } from '../user-settings/setting.interface';
import { BehaviorSubject, Subject, map, takeUntil } from 'rxjs';
import { UserSettingsController } from '../user-settings/user-settings.controller';

export enum EDisplayPriceTariffOption {
  DEAL = 'DEAL',
  BUY = 'BUY',
  SELL = 'SELL',
}

const SETTING = new Setting<EDisplayPriceTariffOption>(
  'basis-best-price-mobile-display-price-tariff-option',
);

@Injectable({
  providedIn: 'root',
})
export class BasisBestPriceMobilePriceOptionsService implements OnDestroy {
  idTextItems = [
    {
      id: EDisplayPriceTariffOption.DEAL,
      text: 'Сделка + тариф',
    },
    {
      id: EDisplayPriceTariffOption.BUY,
      text: 'Спрос + тариф',
    },
    {
      id: EDisplayPriceTariffOption.SELL,
      text: 'Предложение + тариф',
    },
  ];

  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  current$ = new BehaviorSubject<EDisplayPriceTariffOption>(
    EDisplayPriceTariffOption.DEAL,
  );
  currentIdTextItem$ = this.current$.pipe(
    map(
      (current) => this.idTextItems.find((item) => item.id === current) ?? null,
    ),
  );

  constructor(private readonly userSettingsController: UserSettingsController) {
    userSettingsController
      .getSetting(SETTING)
      .pipe(takeUntil(this.destroy$))
      .subscribe((setting) => {
        if (setting) {
          this.current$.next(setting);
        }
      });
  }

  update(value: EDisplayPriceTariffOption) {
    this.current$.next(value);
    this.userSettingsController
      .updateSetting(SETTING, value)
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }
}
